/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mMenu.vue?vue&type=template&id=07a685de&scoped=true"
import script from "./mMenu.vue?vue&type=script&lang=js"
export * from "./mMenu.vue?vue&type=script&lang=js"
import style0 from "./mMenu.vue?vue&type=style&index=0&id=07a685de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a685de",
  null
  
)

export default component.exports